<!-- <nav-bar></nav-bar> -->

<!-- <p-growl [life]="3000" [sticky]="false" [(value)]="messages"></p-growl> -->
<p-toast [life]="3000" [sticky]="false"></p-toast>
<div class="viewchart">
  <!--Services graph-->
  <div class="charts-panel">
    <div class="col-sm-12 col-md-12 col-lg-12 charts-title">
      <div>
        <h2>
          <strong>{{ 'Services' | translate }}</strong>
          <small>
            <span *ngIf="service_date_start.getDate() !== service_date_end.getDate()">
              {{ service_date_start | date:'d' | translate }}
              {{ (service_date_start.getMonth() === service_date_end.getMonth() && service_date_start.getFullYear() === service_date_end.getFullYear())?
                null:service_date_start | date:'MMMM' | translate}}
              {{ service_date_start.getFullYear() !== service_date_end.getFullYear()?
                service_date_start.getFullYear():null}}
              {{ 'to' | translate }}
            </span>
            {{ service_date_end | date:'d' | translate }}
            {{ service_date_end | date:'MMMM' | translate }}
            {{ service_date_start.getFullYear() !== service_date_end.getFullYear()?
                service_date_end.getFullYear():null}}
          </small>
        </h2>
      </div>
      <div style="padding-top: 5px">
        <div class="calendar">
          <div class="input-group" daterangepicker options="dateoption" (selected)="setDate_range($event,'service')">
            <button pButton type="button" class="btn btn-default btn-xs " icon="fa fa-calendar" iconPos="left" style="height: 30px; width: 30px;"></button>
          </div>
        </div>
        <app-casefilter
              [graph_id]="'service'"
              (filter)="onFilters($event)">
        </app-casefilter>

      </div>
    </div>
    <div id="Service_by_Country" class="col-sm-6 col-md-4 col-lg-3 chart-panel" style="clear: both">
      <div class="card full-width">
        <div class="card-container">
          <div class="graph-title">
            <h3>{{ 'Services by Country' | translate }}</h3>
            <div class="select-chart">
              <a *ngIf="chart_format[0]" (click)="selectFormat(0)"><i class="fa fa-pie-chart" aria-hidden="true"></i></a>
              <a *ngIf="!chart_format[0]" (click)="selectFormat(0)"><i class="fa fa-bar-chart" aria-hidden="true"></i></a>
              <a (click)="downloaddata('Service by Country')"><i class="fa fa-download" aria-hidden="true"></i></a>
            </div>
          </div>
          <p-chart *ngIf="!chart_format[0]" type="pie" [data]="country_names" [options]="services_graph_options[0]" height="200"></p-chart>
          <p-chart *ngIf="chart_format[0]" type="bar" [data]="country_names" [options]="services_graph_options[1]" height="200"></p-chart>
        </div>
      </div>
    </div>
    <div id="Services_by_Sponsor" class="col-sm-6 col-md-4 col-lg-3 chart-panel">
      <div class="card full-width">
        <div class="card-container">
          <div class="graph-title">
            <h3>{{ 'Services by Sponsor' | translate }}</h3>
            <div class="select-chart">
              <a *ngIf="chart_format[1]" (click)="selectFormat(1)"><i class="fa fa-pie-chart" aria-hidden="true"></i></a>
              <a *ngIf="!chart_format[1]" (click)="selectFormat(1)"><i class="fa fa-bar-chart" aria-hidden="true"></i></a>
              <a (click)="downloaddata('Services by Sponsor')"><i class="fa fa-download" aria-hidden="true"></i></a>
            </div>
          </div>
          <p-chart *ngIf="!chart_format[1]" type="pie" [data]="product_names" [options]="services_graph_options[0]" height="200"></p-chart>
          <p-chart *ngIf="chart_format[1]" type="bar" [data]="product_names" [options]="services_graph_options[1]" height="200"></p-chart>
        </div>
      </div>
    </div>
    <div id="Services_by_Category" class="col-sm-6 col-md-4 col-lg-3 chart-panel">
      <div class="card full-width">
        <div class="card-container">
          <div class="graph-title">
            <h3>
              {{ 'Services by Category' | translate }}
            </h3>
            <div class="select-chart">
              <a *ngIf="chart_format[2]" (click)="selectFormat(2)"><i class="fa fa-pie-chart" aria-hidden="true"></i></a>
              <a *ngIf="!chart_format[2]" (click)="selectFormat(2)"><i class="fa fa-bar-chart" aria-hidden="true"></i></a>
              <a (click)="downloaddata('Services by Category')"><i class="fa fa-download" aria-hidden="true"></i></a>
            </div>
          </div>
          <p-chart *ngIf="!chart_format[2]" type="pie" [data]="category_data" [options]="services_graph_options[0]" height="200"></p-chart>
          <p-chart *ngIf="chart_format[2]" type="bar" [data]="category_data" [options]="services_graph_options[1]" height="200"></p-chart>
        </div>
        <div></div>
      </div>
    </div>
    <div id="Services" class="col-sm-6 col-md-4 col-lg-3 chart-panel">
      <div class="card full-width">
        <div class="card-container">
          <div class="graph-title">
            <h3>{{ 'Services' | translate }}</h3>
            <div class="select-chart">
              <a *ngIf="chart_format[3]" (click)="selectFormat(3)"><i class="fa fa-pie-chart" aria-hidden="true"></i></a>
              <a *ngIf="!chart_format[3]" (click)="selectFormat(3)"><i class="fa fa-bar-chart" aria-hidden="true"></i></a>
              <a (click)="downloaddata('Services')"><i class="fa fa-download" aria-hidden="true"></i></a>
            </div>
          </div>
          <p-chart *ngIf="!chart_format[3]" type="pie" [data]="services" [options]="services_graph_options[0]" height="200"></p-chart>
          <p-chart *ngIf="chart_format[3]" type="bar" [data]="services" [options]="services_graph_options[1]" height="200"></p-chart>
        </div>
      </div>
    </div>
  </div>

  <!--Client Experience graph-->

    <div id="experience" class="charts-panel">
      <div class="col-sm-12 col-md-12 col-lg-12 charts-title">
        <div>
          <h2>
            <strong>{{ 'Client Experience' | translate }}</strong>
            <small>
              <span *ngIf="experience_date_start.getDate() !== experience_date_end.getDate()">
                {{ experience_date_start | date:'d' | translate }}
                {{ (experience_date_start.getMonth() === experience_date_end.getMonth() && experience_date_start.getFullYear() === experience_date_end.getFullYear())?
                  null:experience_date_start | date:'MMMM' | translate}}
                {{ experience_date_start.getFullYear() !== experience_date_end.getFullYear()?
                  experience_date_start.getFullYear():null}}
                {{ 'to' | translate }}
              </span>
              {{ experience_date_end | date:'d' | translate }}
              {{ experience_date_end | date:'MMMM' | translate }}
              {{ experience_date_start.getFullYear() !== experience_date_end.getFullYear()?
                  experience_date_end.getFullYear():null}}
            </small>
          </h2>
        </div>
        <div style="padding-top: 5px">
          <div class="calendar">
            <div class="input-group" daterangepicker options="dateoption" (selected)="setDate_range($event,'experience')">
              <button pButton type="button" class="btn btn-default btn-xs " icon="fa fa-calendar" iconPos="left" style="height: 30px; width: 30px;"></button>
            </div>
          </div>

          <app-casefilter
              [graph_id]="'experience'"
              (filter)="onFilters($event)">
          </app-casefilter>
        </div>
      </div>
      <div id="BCX_Cabin" class="col-sm-6 col-md-4 col-lg-4 chart-panel" style="clear: both">
        <div class="card full-width">
          <div class="card-container">
            <div class="graph-title">
              <h3>{{ 'BCX Cabin' | translate }}</h3>
              <div class="select-chart">
                <a *ngIf="chart_format[4]" (click)="selectFormat(4)"><i class="fa fa-pie-chart" aria-hidden="true"></i></a>
                <a *ngIf="!chart_format[4]" (click)="selectFormat(4)"><i class="fa fa-bar-chart" aria-hidden="true"></i></a>
                <a (click)="downloaddata('BCX Cabin')"><i class="fa fa-download" aria-hidden="true"></i></a>
              </div>
            </div>
            <p-chart *ngIf="!chart_format[4]" type="pie" [data]="bcx_operatordata_pie" [options]="options2[0]" height="200"></p-chart>
            <p-chart *ngIf="chart_format[4]" type="bar" [data]="bcx_operatordata_bar" [options]="options2[1]" height="200"></p-chart>
          </div>
        </div>
      </div>
      <div id="BCX_Provider" class="col-sm-6 col-md-4 col-lg-4 chart-panel">
        <div class="card full-width">
          <div class="card-container">
            <div class="graph-title">
              <h3>{{ 'BCX Provider' | translate }}</h3>
              <div class="select-chart">
                <a *ngIf="chart_format[5]" (click)="selectFormat(5)"><i class="fa fa-pie-chart" aria-hidden="true"></i></a>
                <a *ngIf="!chart_format[5]" (click)="selectFormat(5)"><i class="fa fa-bar-chart" aria-hidden="true"></i></a>
                <a (click)="downloaddata('BCX Provider')"><i class="fa fa-download" aria-hidden="true"></i></a>
              </div>
            </div>
            <p-chart *ngIf="!chart_format[5]" type="pie" [data]="bcx_providerdata_pie" [options]="options2[0]" height="200"></p-chart>
            <p-chart *ngIf="chart_format[5]" type="bar" [data]="bcx_providerdata_bar" [options]="options2[1]" height="200"></p-chart>
          </div>
        </div>
      </div>
      <div id="CES" class="col-sm-6 col-md-4 col-lg-4 chart-panel">
        <div class="card full-width">
          <div class="card-container">
            <div class="graph-title">
              <h3>{{ 'CES' | translate }}</h3>
              <div class="select-chart">
                <a *ngIf="chart_format[6]" (click)="selectFormat(6)"><i class="fa fa-pie-chart" aria-hidden="true"></i></a>
                <a *ngIf="!chart_format[6]" (click)="selectFormat(6)"><i class="fa fa-bar-chart" aria-hidden="true"></i></a>
                <a (click)="downloaddata('CES')"><i class="fa fa-download" aria-hidden="true"></i></a>
              </div>
            </div>
            <p-chart *ngIf="!chart_format[6]" type="pie" [data]="ces_data_pie" [options]="options2[0]" height="200"></p-chart>
            <p-chart *ngIf="chart_format[6]" type="bar" [data]="ces_data_bar" [options]="options2[1]" height="200"></p-chart>
          </div>
        </div>
      </div>
      <div id="NPS" class="col-sm-6 col-md-4 col-lg-4 chart-panel">
        <div class="card full-width">
          <div class="card-container">
            <div class="graph-title">
              <h3>
                {{ 'NPS' | translate }}:
                <span class="nps-value">
                  {{ nps }}%
                </span>
              </h3>
              <div class="select-chart">
                <a *ngIf="chart_format[7]" (click)="selectFormat(7)"><i class="fa fa-pie-chart" aria-hidden="true"></i></a>
                <a *ngIf="!chart_format[7]" (click)="selectFormat(7)"><i class="fa fa-bar-chart" aria-hidden="true"></i></a>
                <a (click)="downloaddata('NPS')"><i class="fa fa-download" aria-hidden="true"></i></a>
              </div>
            </div>
            <p-chart *ngIf="!chart_format[7]" type="pie" [data]="nps_data_pie" [options]="options2[0]" height="200"></p-chart>
            <p-chart *ngIf="chart_format[7]" type="bar" [data]="nps_data_bar" [options]="options2[1]" height="200"></p-chart>
          </div>
        </div>
      </div>
      <div id="Contactability" class="col-sm-6 col-md-4 col-lg-4 chart-panel">
        <div class="card full-width">
          <div class="card-container">
            <div class="graph-title">
              <h3>
                {{ 'Contactability' | translate }}
              </h3>
              <div class="select-chart">
                <a *ngIf="chart_format[8]" (click)="selectFormat(8)"><i class="fa fa-pie-chart" aria-hidden="true"></i></a>
                <a *ngIf="!chart_format[8]" (click)="selectFormat(8)"><i class="fa fa-bar-chart" aria-hidden="true"></i></a>
                <a (click)="downloaddata('Contactability')"><i class="fa fa-download" aria-hidden="true"></i></a>
              </div>
            </div>
            <p-chart *ngIf="!chart_format[8]" type="pie" [data]="contact_data_pie" [options]="options2[0]" height="200"></p-chart>
            <p-chart *ngIf="chart_format[8]" type="bar" [data]="contact_data_bar" [options]="options2[1]" height="200"></p-chart>
          </div>
        </div>
      </div>
      <div id="Service_Ratings" class="col-sm-12 col-md-12 col-lg-4 chart-panel">
        <div class="card full-width">
          <div class="card-container">
            <div class="graph-title">
              <h3>
                {{ 'Services Ratings' | translate }}
              </h3>
              <div class="select-chart">
                <a (click)="downloaddata('Service Ratings')"><i class="fa fa-download" aria-hidden="true"></i></a>
              </div>
            </div>
            <p-chart type="bar" [data]="service_rating_data" [options]="servicerating_options" height="200"></p-chart>
          </div>
        </div>
      </div>
    </div>

<!--Csaes graph-->

  <div class="charts-panel">
    <div class="col-sm-12 col-md-12 col-lg-12 charts-title">
      <div>
        <h2>
          <strong>{{ 'Cases' | translate }}</strong>
          <small>
              <!--{{ case_date_start | date:'d' | translate }}-->
              {{ case_date_start | date:'MMMM' | translate}}
              {{ case_date_start.getFullYear() !== case_date_end.getFullYear()?
                case_date_start.getFullYear():null}}
              {{ 'to' | translate }}

            <!--{{ case_date_end | date:'d' | translate }}-->
            {{ case_date_end | date:'MMMM' | translate }}
            {{ case_date_start.getFullYear() !== case_date_end.getFullYear()?
                case_date_end.getFullYear():null}}
          </small>
        </h2>
      </div>
      <div style="padding-top: 5px">

        <app-casefilter
              [graph_id]="'case'"
              (filter)="onFilters($event)">
        </app-casefilter>
      </div>
    </div>
    <div id="Cases" class="col-sm-12 col-md-12 col-lg-12 chart-panel">
      <div class="card full-width col-sm-12 col-md-12 col-lg-12">
        <div class="card-container col-sm-12 col-md-12 col-lg-12">
          <div class="graph-title">
            <h3>
              {{ 'Cases' | translate }}{{cases_label}}
            </h3>
            <div class="select-chart">
              <a (click)="downloaddata('Cases')"><i class="fa fa-download" aria-hidden="true"></i></a>
            </div>
          </div>
          <p-chart type="line" [data]="cases" [options]="case_options" height="80"></p-chart>
        </div>
      </div>
    </div>
  </div>

  <!--Attention times graph-->

  <div id="attention" class="charts-panel">
    <div class="col-sm-12 col-md-12 col-lg-12 charts-title">
      <div>
        <h2>
          <strong>{{ 'Attention Times' | translate }}</strong>
          <small>
            <span *ngIf="attention_date_start.getDate() !== attention_date_end.getDate()">
              {{ attention_date_start | date:'d' | translate }}
              {{ (attention_date_start.getMonth() === attention_date_end.getMonth() && attention_date_start.getFullYear() === attention_date_end.getFullYear())?
                null:attention_date_start | date:'MMMM' | translate}}
              {{ attention_date_start.getFullYear() !== attention_date_end.getFullYear()?
                attention_date_start.getFullYear():null}}
              {{ 'to' | translate }}
            </span>
            {{ attention_date_end | date:'d' | translate }}
            {{ attention_date_end | date:'MMMM' | translate }}
            {{ attention_date_start.getFullYear() !== attention_date_end.getFullYear()?
                attention_date_end.getFullYear():null}}
          </small>
        </h2>
      </div>
      <div style="padding-top: 5px">
        <div class="calendar">
          <div class="input-group" daterangepicker options="dateoption" (selected)="setDate_range($event,'attention')">
            <button pButton type="button" class="btn btn-default btn-xs " icon="fa fa-calendar" iconPos="left" style="height: 30px; width: 30px;"></button>
          </div>
        </div>
      </div>
    </div>
    <div id="Road_Assistance" class="col-sm-6 col-md-4 col-lg-4 chart-panel">
      <div class="card full-width">
        <div class="card-container">
          <div class="graph-title">
            <h3>{{ 'Road Assistance' | translate }}</h3>
            <div class="select-chart">
              <a *ngIf="chart_format[9]" (click)="selectFormat(9)"><i class="fa fa-pie-chart" aria-hidden="true"></i></a>
              <a *ngIf="!chart_format[9]" (click)="selectFormat(9)"><i class="fa fa-bar-chart" aria-hidden="true"></i></a>
              <a (click)="downloaddata('Road Assistance')"><i class="fa fa-download" aria-hidden="true"></i></a>
            </div>
          </div>
          <p-chart *ngIf="!chart_format[9]" type="pie" [data]="vial_services_pie" options="options2[0]" height="200"></p-chart>
          <p-chart *ngIf="chart_format[9]" type="bar" [data]="vial_services_bar" options="options2[1]" height="200"></p-chart>
        </div>
      </div>
    </div>
    <div id="Medical_Assistance" class="col-sm-6 col-md-4 col-lg-4 chart-panel">
      <div class="card full-width">
        <div class="card-container">
          <div class="graph-title">
            <h3>{{ 'Medical Assistance' | translate }}</h3>
            <div class="select-chart">
              <a *ngIf="chart_format[10]" (click)="selectFormat(10)"><i class="fa fa-pie-chart" aria-hidden="true"></i></a>
              <a *ngIf="!chart_format[10]" (click)="selectFormat(10)"><i class="fa fa-bar-chart" aria-hidden="true"></i></a>
              <a (click)="downloaddata('Medical Assistance')"><i class="fa fa-download" aria-hidden="true"></i></a>
            </div>
          </div>
          <p-chart *ngIf="!chart_format[10]" type="pie" [data]="medica_services_pie" [options]="options2[0]" height="200"></p-chart>
          <p-chart *ngIf="chart_format[10]" type="bar" [data]="medica_services_bar" [options]="options2[1]" height="200"></p-chart>
        </div>
      </div>
    </div>
    <div id="Home_Assistance" class="col-sm-6 col-md-4 col-lg-4 chart-panel">
      <div class="card full-width">
        <div class="card-container">
          <div class="graph-title">
            <h3>{{ 'Home Assistance' | translate }}</h3>
            <div class="select-chart">
              <a *ngIf="chart_format[11]" (click)="selectFormat(11)"><i class="fa fa-pie-chart" aria-hidden="true"></i></a>
              <a *ngIf="!chart_format[11]" (click)="selectFormat(11)"><i class="fa fa-bar-chart" aria-hidden="true"></i></a>
              <a (click)="downloaddata('Home Assistance')"><i class="fa fa-download" aria-hidden="true"></i></a>
            </div>
          </div>
          <p-chart *ngIf="!chart_format[11]" type="pie" [data]="hogar_services_pie" [options]="options2[0]" height="200"></p-chart>
          <p-chart *ngIf="chart_format[11]" type="bar" [data]="hogar_services_bar" [options]="options2[1]" height="200"></p-chart>
        </div>
      </div>
    </div>
  </div>

  <!--Financial graph-->

  <div id="financial" class="charts-panel">
    <div class="col-sm-12 col-md-12 col-lg-12 charts-title">
      <div>
        <h2>
          <strong>{{ 'Financial' | translate }}</strong>
          <small>
            <span *ngIf="financial_date_start.getDate() !== financial_date_end.getDate()">
              {{ financial_date_start | date:'d' | translate }}
              {{ (financial_date_start.getMonth() === financial_date_end.getMonth() && financial_date_start.getFullYear() === financial_date_end.getFullYear())?
                null:financial_date_start | date:'MMMM' | translate}}
              {{ financial_date_start.getFullYear() !== financial_date_end.getFullYear()?
                financial_date_start.getFullYear():null}}
              {{ 'to' | translate }}
            </span>
            {{ financial_date_end | date:'d' | translate }}
            {{ financial_date_end | date:'MMMM' | translate }}
            {{ financial_date_start.getFullYear() !== financial_date_end.getFullYear()?
                financial_date_end.getFullYear():null}}
          </small>
        </h2>
      </div>
      <div style="padding-top: 5px">
        <div class="calendar">
          <div class="input-group" daterangepicker options="dateoption" (selected)="setDate_range($event,'financial')">
            <button pButton type="button" class="btn btn-default btn-xs " icon="fa fa-calendar" iconPos="left" style="height: 30px; width: 30px;"></button>
          </div>
        </div>

        <app-casefilter
              [graph_id]="'financial'"
              (filter)="onFilters($event)">
        </app-casefilter>
      </div>
    </div>
    <div id="Categories" class="col-sm-6 col-md-6 col-lg-6 chart-panel" style="clear: both">
      <div class="card full-width col-sm-12">
        <div class="card-container col-sm-12">
          <div class="graph-title">
            <h3>{{ 'Categories' | translate }}</h3>
            <div class="select-chart">
              <a (click)="downloaddata('Categories')"><i class="fa fa-download" aria-hidden="true"></i></a>
            </div>
          </div>
          <p-chart type="bar" [data]="bills" [options]="options3" height="150"></p-chart>
        </div>
      </div>
    </div>
    <div id="Expenses_vs_Income" class="col-sm-6 col-md-6 col-lg-6 chart-panel">
      <div class="card full-width col-sm-12">
        <div class="card-container col-sm-12">
          <h3>{{ 'Expenses vs Income' | translate }}</h3>
          <div class="select-chart">
            <a (click)="downloaddata('Expenses vs Income')"><i class="fa fa-download" aria-hidden="true"></i></a>
          </div>
          <p-chart type="bar" [data]="saleitems" [options]="options4" height="150"></p-chart>
        </div>
      </div>
    </div>
  </div>

  <!--Providers graph-->

  <div id = "assistance_providers" class="charts-panel col-sm-6 col-md-6 col-lg-6">
    <div class="col-sm-12 col-md-12 col-lg-12 charts-title">
      <div>
        <h2>
          <strong>{{ 'Assistance Providers' | translate }}</strong>          
        </h2>
      </div>      
    </div>
    <div id="assistance_providers_1" class="col-sm-12 col-md-12 col-lg-12 chart-panel">
      <div class="card full-width col-sm-12 col-md-12 col-lg-12">
        <div class="card-container col-sm-12 col-md-12 col-lg-12">
          <div class="graph-title">     
            <h3>{{ 'Assistance Providers' | translate }}</h3>       
            <div class="select-chart">
              <a *ngIf="chart_format[0]" (click)="selectFormat(12)"><i class="fa fa-pie-chart" aria-hidden="true"></i></a>
              <a *ngIf="!chart_format[0]" (click)="selectFormat(12)"><i class="fa fa-bar-chart" aria-hidden="true"></i></a>
              <a (click)="downloaddata('assistance_providers')"><i class="fa fa-download" aria-hidden="true"></i></a>
            </div>
          </div>
          <p-chart *ngIf="!chart_format[12]" type="pie" [data]="providers_data_pie" [options]="providers_graph_options[0]" height="200"></p-chart>
          <p-chart *ngIf="chart_format[12]" type="bar" [data]="providers_data_bar" [options]="providers_graph_options[1]" height="200"></p-chart>
        </div>
      </div>
    </div>
  </div>

</div>

<p-dialog
  header="{{ 'Download' | translate }} {{ download_chartname | translate }} {{'Data' | translate }}"
  [(visible)]="showDownloadDialog" [responsive]="true"
  [modal]="true" [draggable]="false"
  [breakpoint]="500" [blockScroll]="true">
  <div class="form-horizontal download-form">
    <div class="form-group">
      <label class="control-label col-sm-3">
        {{ 'Select Item' | translate }}:
      </label>
      <div class="col-sm-9">
        <select class="form-control" [(ngModel)]="downloadItem" name="download">
          <option *ngFor="let item of downloadItems" [ngValue]="item.value">
            <span>
              {{ item.name | translate }}
            </span>
          </option>
        </select>
      </div>
    </div>
    <div class="form-group" *ngIf="downloadItem === 2">
      <label class="control-label col-sm-3">{{ 'File Type' | translate }}:</label>
      <div class="col-sm-9">
        <select class="form-control" [(ngModel)]="fileType"  name="file_type">
          <option value="csv">CSV</option>
          <option value="xlsx">XLSX</option>
        </select>
      </div>
    </div>
    <div class="form-group">
      <div class="col-sm-offset-3 col-sm-9 div-btn-right">
        <button type="button" class="btn btn-default btn-sm" (click)="onDownloadCancel()">{{ 'Cancel' | translate }}</button>
        <button type="submit" class="btn btn-primary btn-sm" (click)="onDownload()">{{ 'Download' | translate }}
        </button>
      </div>
    </div>
  </div>
</p-dialog>
